<template>
  <AppWithLoading v-slot:default="{loader, localLoading}">
    <div v-if="!localLoading">
      <div class="vacancy-list-item-error">
        <template>
          <div class="vacancy-list-item-error__left-wrap">
            <svg
              class="vacancy-list-item-error__icon"
              width="31"
              height="31"
              viewBox="0 0 31 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M22.025 1H8.975L1 8.975V22.025L8.975 30H22.025L30 22.025V8.975L22.025 1Z" stroke="#EA0D0D" stroke-miterlimit="10" />
              <path
                d="M15.5 19.85C14.2675 19.85 13.325 20.7925 13.325 22.025C13.325 23.2575 14.2675 24.2 15.5 24.2C16.7325 24.2 17.675 23.2575 17.675 22.025C17.675 20.7925 16.7325 19.85 15.5 19.85Z"
                stroke="#EA0D0D"
                stroke-miterlimit="10"
                stroke-linejoin="round"
              />
              <path
                d="M15.5001 16.9501C16.2976 16.9501 16.8051 16.5151 16.9501 15.8626C17.0951 15.2101 17.5301 10.7151 17.6751 8.32257C17.7476 7.01757 16.7326 6.07507 15.5001 6.07507C14.2676 6.07507 13.2526 7.01757 13.3251 8.32257C13.4701 10.7151 13.9051 15.2101 14.0501 15.8626C14.1951 16.5151 14.7026 16.9501 15.5001 16.9501Z"
                stroke="#EA0D0D"
                stroke-miterlimit="10"
                stroke-linejoin="round"
              />
            </svg>
            <div class="vacancy-list-item-error__text">
              {{ $t('deleteVacancyList') }}
            </div>
          </div>
        </template>
        <div class="vacancy-list-item-error__right-wrap">
          <button class="vacancy-list-item-error__btn vacancy-list-item-error__btn_delete" @click="loader(() => deleteVacancyList())">
            {{ $t('delete') }}
          </button>
          <button class="vacancy-list-item-error__btn" @click="$emit('closed')">
            {{ $t('cancel') }}
          </button>
        </div>
      </div>
    </div>
  </AppWithLoading>
</template>

<script>
import AppWithLoading from '@/components/AppWithLoading';
import { ref, toRefs } from '@vue/composition-api';
import useVacanciesList from '@/compositions/useVacanciesList';

export default {
  name: 'VacancyListDeleteDialog',
  components: { AppWithLoading },
  props: {
    vacancyList: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const dialog = ref(false);
    const { vacancyList } = toRefs(props);
    const { destroy } = useVacanciesList();

    async function deleteVacancyList() {
      dialog.value = false;
      await destroy(vacancyList.value?.id);
      emit('destroyed');
    }

    return {
      dialog,
      deleteVacancyList,
    };
  },
};
</script>

<style lang="scss" scoped>
.vacancy-list-item-error {
  display: flex;
  align-items: center;
  background: rgba(234, 13, 13, 0.1);
  border-radius: 0.375rem;
  padding: 0.875rem 1.125rem 0.875rem;
  &__icon {
    max-width: 1.8125rem;
    min-width: 1.8125rem;
    margin-right: 0.75rem;
  }
  &__text {
    font-size: 0.875rem;
    line-height: 1.14;
    color: #EA0D0D;
    margin-right: 0.9375rem;
  }
  &__left-wrap {
    display: flex;
    align-items: center;
  }
  &__right-wrap {
    display: flex;
    margin-left: 1.25rem;
  }
  &__btn {
    width: 7.5rem;
    padding: 0.4375rem 1.25rem;
    font-size: 0.875rem;
    line-height: 1.2;
    color: #000000;
    letter-spacing: 0.02em;
    border-radius: 0.25rem;
    border: 1px solid #D6D6D6;
    &_delete {
      color: #EA0D0D;
      border-color: #EA0D0D;
      margin-right: 0.625rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .vacancy-list-item-error {
    flex-wrap: wrap;
    &__icon {
      margin-bottom: 1rem;
    }
    &__text {
      margin-right: 0;
      margin-bottom: 1rem;
    }
    &__right-wrap {
      width: 100%;
      justify-content: center;
      margin-right: 0;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .vacancy-list-item-error {
    display: flex;
    flex-wrap: wrap;
    padding: 0.875rem 0.9375rem 0.875rem;
    &__icon {
      max-width: 1.5rem;
      min-width: 1.5rem;
      margin-right: 0.625rem;
    }
    &__text {
      font-size: 0.75rem;
    }
    &__btn {
      width: 7.5rem;
      padding: 0.4375rem 1rem;
      font-size: 0.75rem;
      &_delete {
        margin-right: 0.5rem;
      }
    }
  }
}
</style>

<i18n lang="yml" locale="ru">
deleteVacancyList: Страница с подборкой вакансий будет удалена, а QR-код перестанет работать.
delete: Удалить
cancel: Отмена
</i18n>
<i18n lang="yml" locale="en">
deleteVacancyList: If you delete this job selection, your QR code will no longer work.
delete: Delete
cancel: Cancel
</i18n>
